// src/components/VisitorContactWidget/data/contactWidgetData.js

export const CONTACT_WIDGET_VIEWS = {
  HOME: "home",
  QUESTION: "question",
  CHAT: "chat",
  CALLBACK: "callback",
  DEMO: "demo",
  SUCCESS: "success",
};

export const PRODUCT_OPTIONS = [
  {
    value: "",
    label: "Sélectionner une application",
  },
  {
    value: "MonAppliClub Standard",
    label: "MonAppliClub Standard",
  },
  {
    value: "MonAppliClub Light",
    label: "MonAppliClub Light",
  },
  {
    value: "MonAppliTournoi",
    label: "MonAppliTournoi",
  },
  {
    value: "MonAppliBénévoles",
    label: "MonAppliBénévoles",
  },
  {
    value: "MonAppliConformité",
    label: "MonAppliConformité",
  },
  {
    value: "MonAppliMairie",
    label: "MonAppliMairie",
  },
  {
    value: "MonAppliAsso",
    label: "MonAppliAsso",
  },
  {
    value: "Autre projet",
    label: "Autre projet",
  },
];

export const CALLBACK_TIME_OPTIONS = [
  {
    value: "",
    label: "Choisir un créneau",
  },
  {
    value: "Matin entre 9h et 12h",
    label: "Matin, entre 9h et 12h",
  },
  {
    value: "Après-midi entre 14h et 17h",
    label: "Après-midi, entre 14h et 17h",
  },
  {
    value: "Fin de journée entre 17h et 20h",
    label: "Fin de journée, entre 17h et 20h",
  },
  {
    value: "Peu importe",
    label: "Peu importe",
  },
];

export const IGNORED_WIDGET_PREFIXES = [
  "/appli",
  "/dashboard",
  "/connexion",
  "/login",
  "/logout",
];

export function detectProductFromPath(pathname = "") {
  const path = pathname.toLowerCase();

  if (path.includes("tournoi")) {
    return "MonAppliTournoi";
  }

  if (path.includes("benevole")) {
    return "MonAppliBénévoles";
  }

  if (path.includes("conformite")) {
    return "MonAppliConformité";
  }

  if (path.includes("mairie")) {
    return "MonAppliMairie";
  }

  if (path.includes("asso")) {
    return "MonAppliAsso";
  }

  if (
    path.includes("light") ||
    path.includes("site-internet")
  ) {
    return "MonAppliClub Light";
  }

  if (
    path.includes("standard") ||
    path.includes("monappliclub")
  ) {
    return "MonAppliClub Standard";
  }

  return "";
}